import { Component} from '@angular/core';

@Component({
  selector: 'app-staticaging-vertical-header',
  standalone: false,
  templateUrl: './static-aging-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class StaticAgingVerticalHeaderComponent {

}
